import { Injectable, ɵɵdefineInjectable, Component, Input, EventEmitter, Output, ViewChild, NgModule } from '@angular/core';
import { Observable, Subject, Subscription, combineLatest, merge, of } from 'rxjs';
import { Validators, FormGroup, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { isValueWholeNumber, validateYearFormat, validatePostalCode, validateDateFormat, isDateInThePast, validatePhoneNumber, validateEmailAddress, validateRiskUnitsNumber, validateDateWithinRange, validateDateWithinRangeOfDate, requiredByValues, validateDateNotAfter, requiredByValuesExceptWhen, requiredByRule, requiredWhenNotEmpty, requiredByOperation, validateName, enabledByValues } from 'collabor8-funcs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { startWith, map, shareReplay, filter } from 'rxjs/operators';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskModule } from 'ngx-mask';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/validators/backend-validation.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const isValueWholeNumberWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return isValueWholeNumber(control.value);
});
/** @type {?} */
const validateYearFormatWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return validateYearFormat(control.value);
});
/** @type {?} */
const validatePostalCodeWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return validatePostalCode(control.value);
});
/** @type {?} */
const validateDateFormatWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return validateDateFormat(control.value);
});
/** @type {?} */
const isDateInThePastWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return isDateInThePast(control.value);
});
/** @type {?} */
const validatePhoneNumberWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return validatePhoneNumber(control.value);
});
/** @type {?} */
const validateEmailAddressWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return validateEmailAddress(control.value);
});
/** @type {?} */
const validateRiskUnitsNumberWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return validateRiskUnitsNumber(control.value);
});
/** @type {?} */
const validateDateWithinRangeWrapper = (/**
 * @param {?} min
 * @param {?} max
 * @return {?}
 */
(min, max) => {
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        return validateDateWithinRange(control.value, min, max);
    });
});
/** @type {?} */
const validateDateWithinRangeOfDateWrapper = (/**
 * @param {?} field
 * @param {?} min
 * @param {?} max
 * @return {?}
 */
(field, min, max) => {
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        return validateDateWithinRangeOfDate(control.value, field.value, min, max);
    });
});
/** @type {?} */
const requiredByValuesWrapper = (/**
 * @param {?} field
 * @param {?} requiredValues
 * @param {?=} invert
 * @return {?}
 */
(field, requiredValues, invert = false) => {
    /** @type {?} */
    let subscriptionCreated = false;
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        if (!subscriptionCreated && field.valueChanges) {
            subscriptionCreated = true;
            field.valueChanges.subscribe((/**
             * @return {?}
             */
            () => {
                control.updateValueAndValidity({ emitEvent: false });
            }));
        }
        return requiredByValues(control.value, field.value, requiredValues, invert);
    });
});
/** @type {?} */
const validateDateNotAfterWrapper = (/**
 * @param {?} field
 * @param {?=} label
 * @return {?}
 */
(field, label) => {
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        return validateDateNotAfter(control.value, field === null || field === void 0 ? void 0 : field.value, label);
    });
});
/** @type {?} */
const requiredByValuesExceptWhenWrapper = (/**
 * @param {?} field
 * @param {?} requiredValues
 * @param {?} exceptField
 * @param {?} exceptValues
 * @return {?}
 */
(field, requiredValues, exceptField, exceptValues) => {
    /** @type {?} */
    let subscriptionCreated = false;
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        if (!subscriptionCreated) {
            subscriptionCreated = true;
            [field, exceptField].forEach((/**
             * @param {?} source
             * @return {?}
             */
            source => { var _a; return (_a = source === null || source === void 0 ? void 0 : source.valueChanges) === null || _a === void 0 ? void 0 : _a.subscribe((/**
             * @return {?}
             */
            () => {
                control.updateValueAndValidity({ emitEvent: false });
            })); }));
        }
        return requiredByValuesExceptWhen(control.value, field.value, requiredValues, exceptField === null || exceptField === void 0 ? void 0 : exceptField.value, exceptValues);
    });
});
/** @type {?} */
const requiredByRuleWrapper = (/**
 * @param {?} getIsRuleActive
 * @param {?=} invert
 * @return {?}
 */
(getIsRuleActive, invert = false) => {
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        return requiredByRule(control.value, getIsRuleActive(), invert);
    });
});
/** @type {?} */
const requiredWhenNotEmptyWrapper = (/**
 * @param {?} field
 * @param {?=} invert
 * @return {?}
 */
(field, invert = false) => {
    /** @type {?} */
    let subscriptionCreated = false;
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        if (!subscriptionCreated && field.valueChanges) {
            subscriptionCreated = true;
            field.valueChanges.subscribe((/**
             * @return {?}
             */
            () => {
                control.updateValueAndValidity({ emitEvent: false });
            }));
        }
        return requiredWhenNotEmpty(control.value, field.value, invert);
    });
});
/** @type {?} */
const requiredByOperationWrapper = (/**
 * @param {?} field
 * @param {?} requiredValue
 * @param {?} op
 * @return {?}
 */
(field, requiredValue, op) => {
    /** @type {?} */
    let subscriptionCreated = false;
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        if (!subscriptionCreated && field.valueChanges) {
            subscriptionCreated = true;
            field.valueChanges.subscribe((/**
             * @return {?}
             */
            () => {
                control.updateValueAndValidity({ emitEvent: false });
            }));
        }
        return requiredByOperation(control.value, field.value, requiredValue, op);
    });
});
/** @type {?} */
const validateNameWrapper = (/**
 * @param {?} control
 * @return {?}
 */
(control) => {
    return validateName(control.value);
});
/** @type {?} */
const enabledByValuesWrapper = (/**
 * @param {?} field
 * @param {?} requiredValues
 * @param {?} numOfInstances
 * @param {?=} invert
 * @return {?}
 */
(field, requiredValues, numOfInstances, invert = false) => {
    /** @type {?} */
    const applyEnablingState = (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        /** @type {?} */
        let shouldEnable = false;
        control["_enableByValuesCond"].forEach((/**
         * @param {?} __0
         * @return {?}
         */
        ({ source, requiredValues, invert }) => {
            shouldEnable = shouldEnable || enabledByValues(source.value, requiredValues, invert);
        }));
        if (shouldEnable && control.disabled) {
            control.enable({ emitEvent: false });
            control.updateValueAndValidity({ emitEvent: false });
        }
        else if (!shouldEnable) {
            if (control.enabled) {
                control.disable({ emitEvent: false });
                control.setValue(null, { emitEvent: false });
            }
            control.setErrors(null);
        }
    });
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        if (!control["_enableByValuesCond"]) {
            control["_enableByValuesCond"] = [];
        }
        if (!control["_enableByValuesCond"].find((/**
         * @param {?} c
         * @return {?}
         */
        c => c.source == field))) {
            control["_enableByValuesCond"].push({ source: field, requiredValues: requiredValues, invert: invert });
        }
        if (control["_enableByValuesCond"].length == numOfInstances) {
            for (const enableCond of control["_enableByValuesCond"]) {
                ((/** @type {?} */ (['setValue', 'patchValue']))).forEach((/**
                 * @param {?} method
                 * @return {?}
                 */
                method => {
                    /** @type {?} */
                    const original = enableCond.source[method].bind(enableCond.source);
                    enableCond.source[method] = (/**
                     * @param {...?} args
                     * @return {?}
                     */
                    (...args) => { original(...args); applyEnablingState(control); });
                }));
                enableCond.source.valueChanges.subscribe((/**
                 * @return {?}
                 */
                () => applyEnablingState(control)));
            }
            applyEnablingState(control);
        }
    });
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/validators/validation.factory.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const validatorFuncs = {
    "isValueWholeNumber": isValueWholeNumberWrapper,
    "validateYearFormat": validateYearFormatWrapper,
    "validatePostalCode": validatePostalCodeWrapper,
    "validateDateFormat": validateDateFormatWrapper,
    "isDateInThePast": isDateInThePastWrapper,
    "validatePhoneNumber": validatePhoneNumberWrapper,
    "validateEmailAddress": validateEmailAddressWrapper,
    "validateRiskUnitsNumber": validateRiskUnitsNumberWrapper,
    "validateDateWithinRange": validateDateWithinRangeWrapper,
    "validateDateNotAfter": validateDateNotAfterWrapper,
    "validateDateWithinRangeOfDate": validateDateWithinRangeOfDateWrapper,
    "requiredByValues": requiredByValuesWrapper,
    "requiredByValuesExceptWhen": requiredByValuesExceptWhenWrapper,
    "requiredByRule": requiredByRuleWrapper,
    "enabledByValues": enabledByValuesWrapper,
    "requiredWhenNotEmpty": requiredWhenNotEmptyWrapper,
    "requiredByOperation": requiredByOperationWrapper,
    "validateName": validateNameWrapper
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/default.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} validations
 * @param {?} type
 * @return {?}
 */
function defaultValidator(validations, type) {
    /** @type {?} */
    let validators = [];
    if (validations != null && type != "checkbox") {
        for (let i = 0; i < validations.default.length; i++) {
            switch (validations.default[i]) {
                case 'min':
                    validators.push(Validators.min(validations.default[i + 1]));
                    break;
                case 'max':
                    validators.push(Validators.max(validations.default[i + 1]));
                    break;
                case 'required':
                    validators.push(Validators.required);
                    break;
                case 'requiredTrue':
                    validators.push(Validators.requiredTrue);
                    break;
                case 'email':
                    validators.push(Validators.email);
                    break;
                case 'minLength':
                    validators.push(Validators.minLength(validations.default[i + 1]));
                    break;
                case 'maxLength':
                    validators.push(Validators.maxLength(validations.default[i + 1]));
                    break;
                case 'pattern':
                    validators.push(Validators.pattern);
                    break;
            }
        }
    }
    return validators;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/validators/custom-validations.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const shouldUpdateValidators = (/**
 * @param {?} newValidators
 * @param {?} previousValidators
 * @return {?}
 */
(newValidators, previousValidators) => {
    if (newValidators.length != previousValidators.length)
        return true;
    /** @type {?} */
    const prevFuncs = previousValidators.map((/**
     * @param {?} func
     * @return {?}
     */
    func => func.toString()));
    return !newValidators.every((/**
     * @param {?} func
     * @return {?}
     */
    func => prevFuncs.includes(func.toString())));
});
const ɵ0 = shouldUpdateValidators;
/** @type {?} */
const getFieldValidations = (/**
 * @param {?} field
 * @param {?=} control
 * @return {?}
 */
(field, control) => {
    /** @type {?} */
    const syncValidations = [];
    if (field.validations != null) {
        /** @type {?} */
        const func = field.validations.custom.func;
        if (Array.isArray(func)) {
            for (const fn of func) {
                syncValidations.push(validatorFuncs[fn]);
            }
        }
    }
    if (field.type === "year")
        syncValidations.push(validatorFuncs["validateYearFormat"]);
    else if (field.type === "date")
        syncValidations.push(validatorFuncs["validateDateFormat"]);
    else if (field.type === "phoneNumber")
        syncValidations.push(validatorFuncs["validatePhoneNumber"]);
    syncValidations.push(...defaultValidator(field.validations, field.type));
    return syncValidations;
});
/** @type {?} */
const setRequiredValidation = (/**
 * @param {?} requireOnConfig
 * @param {?} formGroup
 * @param {?} formJson
 * @return {?}
 */
(requireOnConfig, formGroup, formJson) => {
    /** @type {?} */
    let prevState = {};
    return (/**
     * @param {?} control
     * @return {?}
     */
    (control) => {
        const { validatorForm, validatorField, conditionalField, values, invertValues } = requireOnConfig;
        /** @type {?} */
        const validations = getFieldValidations(formJson.find((/**
         * @param {?} f
         * @return {?}
         */
        f => f.name == validatorForm)).parameters.find((/**
         * @param {?} field
         * @return {?}
         */
        field => field.name == validatorField)));
        if ((Array.isArray(values) && (values.includes(control.get(conditionalField).value) || (control.get(conditionalField).value == undefined && values.includes(null))) != (invertValues == undefined ? false : invertValues)) ||
            ((!Array.isArray(values) && values != undefined) && (values == control.get(conditionalField).value) != (invertValues == undefined ? false : invertValues)) ||
            (values == undefined && control.get(conditionalField).value == true)) {
            validations.push(Validators.required);
        }
        formGroup[validatorForm].get(validatorField).setValidators(Validators.compose([...validations]));
        /** @type {?} */
        const fieldKey = `${validatorForm}-${validatorField}`
        //Need to track this field's previous validator state, so it doesn't get infinitely updated
        ;
        //Need to track this field's previous validator state, so it doesn't get infinitely updated
        if (!(fieldKey in prevState) || (fieldKey in prevState && shouldUpdateValidators(validations, prevState[fieldKey]))) {
            prevState[fieldKey] = validations;
            formGroup[validatorForm].get(validatorField).updateValueAndValidity({ emitEvent: false });
        }
        return null;
    });
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-tab.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormTabService {
    constructor() {
        this.ruleValidatedControls = new Map();
    }
    /**
     * @param {?} formJsonConfig
     * @param {?} formValues
     * @return {?}
     */
    initForm(formJsonConfig, formValues) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            this.formJson = JSON.parse(formJsonConfig);
            this.formValuesJson = JSON.parse(formValues);
            if (this.formJson === null) {
                return;
            }
            // If formValues is a JSON array, multiple forms must be initialized
            if (Array.isArray(this.formValuesJson) && this.formValuesJson.length > 0) {
                /** @type {?} */
                const len = this.formValuesJson.length;
                /** @type {?} */
                const formValues = this.formValuesJson;
                for (let i = 0; i < len; i++) {
                    this.formValuesJson = formValues[i];
                    // id - caimid, locid, etc
                    observer.next({ id: this.formValuesJson.id, form: this.toFormGroup(this.formJson, this.formValuesJson), orderedFormJson: this.formJson });
                }
            }
            else {
                observer.next({ form: this.toFormGroup(this.formJson, this.formValuesJson), orderedFormJson: this.formJson });
            }
            observer.complete();
        }));
    }
    /**
     * @param {?} control
     * @param {?} name
     * @return {?}
     */
    findControlByName(control, name) {
        if (control.controls) {
            for (const key in control.controls) {
                if (key == name)
                    return control.controls[key];
                /** @type {?} */
                const result = this.findControlByName(control.controls[key], name);
                if (result)
                    return result;
            }
        }
        return null;
    }
    /**
     * @param {?} formGroup
     * @param {?} name
     * @return {?}
     */
    findCoverageControlByName(formGroup, name) {
        var _a, _b;
        for (let form in formGroup.controls) {
            /** @type {?} */
            const coverage = (_b = (_a = formGroup.get(form).get("Coverages")) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.find((/**
             * @param {?} coverage
             * @return {?}
             */
            coverage => coverage.get("CoverageNameCd").value == name));
            if (coverage) {
                return coverage.get("CoverageSelectedInd");
            }
        }
        return undefined;
    }
    /**
     * Setup the parameterized validations on the thisFormGroup based on the formModel
     * @param {?} formModel the form model with the parameterized validations
     * @param {?} thisFormGroup the form group created from the form model (which will have the parameterized validations setup)
     * @param {?=} targetFormGroup the form group with the target field to validate against (defaults to the same as thisFormGroup)
     * @return {?}
     */
    setupParameterizedValidations(formModel, thisFormGroup, targetFormGroup = thisFormGroup) {
        formModel.forEach((/**
         * @param {?} section
         * @return {?}
         */
        section => {
            section.parameters.forEach((/**
             * @param {?} field
             * @return {?}
             */
            field => {
                var _a, _b;
                if (!((_a = field.validations) === null || _a === void 0 ? void 0 : _a.parameterizedFuncs))
                    return;
                /** @type {?} */
                const thisControl = this.findControlByName(thisFormGroup, field.name);
                if (!thisControl)
                    return;
                /** @type {?} */
                const baseValidations = getFieldValidations(field);
                for (const [fn, instances] of Object.entries((/** @type {?} */ ((_b = field.validations) === null || _b === void 0 ? void 0 : _b.parameterizedFuncs)))) {
                    for (const instance of Object.values(instances)) {
                        /** @type {?} */
                        const paramArgs = [];
                        /** @type {?} */
                        let hasFieldReference = false;
                        for (const arg of instance) {
                            if (["$", "#"].includes(arg[0])) {
                                /** @type {?} */
                                let targetControl = null;
                                if (arg[0] == "$")
                                    targetControl = this.findControlByName(targetFormGroup, arg.slice(1).trim());
                                else if (arg[0] == "#")
                                    targetControl = this.findCoverageControlByName(targetFormGroup, arg.slice(1).trim());
                                if (targetControl) {
                                    hasFieldReference = true;
                                    paramArgs.push(targetControl);
                                }
                            }
                            else {
                                paramArgs.push(arg);
                            }
                        }
                        if (hasFieldReference && paramArgs[0]) {
                            if (fn == "enabledByValues") {
                                /** @type {?} */
                                const numOfInstances = Object.keys(instances).length;
                                baseValidations.push(((/** @type {?} */ (validatorFuncs[fn])))(...paramArgs, numOfInstances));
                            }
                            else {
                                baseValidations.push(validatorFuncs[fn](...paramArgs));
                            }
                        }
                        else if (!hasFieldReference && paramArgs.length > 0 && validatorFuncs[fn] && fn == "validateDateWithinRange") {
                            baseValidations.push(((/** @type {?} */ (validatorFuncs[fn])))(...paramArgs));
                        }
                    }
                }
                // Get existing validators and combine with new ones (Angular 8 doesn't have addValidators)
                /** @type {?} */
                const existingValidators = thisControl.validator ? [thisControl.validator] : [];
                /** @type {?} */
                const allValidators = [...existingValidators, ...baseValidations];
                thisControl.setValidators(Validators.compose(allValidators));
                thisControl.updateValueAndValidity({ onlySelf: true, emitEvent: true });
            }));
        }));
    }
    /**
     * @param {?} formModel
     * @param {?} thisFormGroup
     * @param {?=} getOpinions
     * @param {?=} formId
     * @return {?}
     */
    setupRuleBasedValidations(formModel, thisFormGroup, getOpinions = (/**
     * @return {?}
     */
    () => []), formId) {
        formModel.forEach((/**
         * @param {?} section
         * @return {?}
         */
        section => {
            var _a;
            (_a = section.parameters) === null || _a === void 0 ? void 0 : _a.forEach((/**
             * @param {?} field
             * @return {?}
             */
            field => {
                var _a, _b;
                /** @type {?} */
                const requiredByRule = (_a = field.validations) === null || _a === void 0 ? void 0 : _a.requiredByRule;
                if (!(requiredByRule === null || requiredByRule === void 0 ? void 0 : requiredByRule.rule))
                    return;
                /** @type {?} */
                const thisControl = this.findControlByName(thisFormGroup, field.name);
                if (!thisControl)
                    return;
                /** @type {?} */
                const validationKey = `${formId != null ? formId : 'global'}:${field.name}:${requiredByRule.rule}`;
                if (this.ruleValidatedControls.has(validationKey)) {
                    this.ruleValidatedControls.delete(validationKey);
                }
                /** @type {?} */
                const invert = (_b = requiredByRule.invert) !== null && _b !== void 0 ? _b : false;
                /** @type {?} */
                const getIsRuleActive = (/**
                 * @return {?}
                 */
                () => {
                    var _a;
                    /** @type {?} */
                    const opinions = (_a = getOpinions()) !== null && _a !== void 0 ? _a : [];
                    return opinions.some((/**
                     * @param {?} o
                     * @return {?}
                     */
                    o => o.ruleName === requiredByRule.rule));
                });
                /** @type {?} */
                const baseValidations = getFieldValidations(field);
                baseValidations.push(requiredByRuleWrapper(getIsRuleActive, invert));
                /** @type {?} */
                const existingValidators = thisControl.validator ? [thisControl.validator] : [];
                thisControl.setValidators(Validators.compose([...existingValidators, ...baseValidations]));
                this.ruleValidatedControls.set(validationKey, thisControl);
                thisControl.updateValueAndValidity({ onlySelf: true, emitEvent: true });
            }));
        }));
    }
    /**
     * @param {?} formId
     * @return {?}
     */
    clearRuleBasedValidations(formId) {
        /** @type {?} */
        const prefix = `${formId}:`;
        Array.from(this.ruleValidatedControls.keys()).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            if (key.startsWith(prefix)) {
                this.ruleValidatedControls.delete(key);
            }
        }));
    }
    /**
     * @return {?}
     */
    refreshRuleBasedValidations() {
        this.ruleValidatedControls.forEach((/**
         * @param {?} control
         * @return {?}
         */
        control => {
            control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }));
    }
    /**
     * @param {?} formModel
     * @param {?} formValues
     * @return {?}
     */
    toFormGroup(formModel, formValues) {
        /** @type {?} */
        let formGroup = {};
        /** @type {?} */
        let formControls = [];
        formModel.forEach((/**
         * @param {?} field
         * @return {?}
         */
        field => {
            if (field.type == 'object') {
                if (field.parameters != null) {
                    formGroup[field.name] = this.toFormGroupFromArr(field.parameters);
                    if (field.conditionalRequirements != null) {
                        /** @type {?} */
                        const conditionalRequirementsArray = field.conditionalRequirements;
                        /** @type {?} */
                        const validators = [];
                        for (const conditionalRequirement of conditionalRequirementsArray) {
                            validators.push(setRequiredValidation(conditionalRequirement, formGroup, formModel));
                        }
                        formGroup[field.name].setValidators(Validators.compose(validators));
                    }
                }
            }
            else {
                formControls.push({ name: field.name, control: this.appendFieldFormControlToObject(field)[field.name] });
            }
        }));
        /** @type {?} */
        let form = new FormGroup(formGroup);
        formControls.forEach((/**
         * @param {?} f
         * @return {?}
         */
        f => {
            form.addControl(f.name, f.control);
        }));
        // check if any custom validation functions have a field control as a parameter
        this.setupParameterizedValidations(formModel, form);
        return form;
    }
    /**
     * @param {?} arr
     * @return {?}
     */
    toFormGroupFromArr(arr) {
        return new FormGroup(arr.reduce((/**
         * @param {?} acc
         * @param {?} cur
         * @return {?}
         */
        (acc, cur) => {
            return this.appendFieldFormControlToObject(cur, acc);
        }), {}));
    }
    /**
     * @param {?} field
     * @param {?=} obj
     * @return {?}
     */
    appendFieldFormControlToObject(field, obj = {}) {
        if (field.type == 'object') {
            obj[field.name] = this.toFormGroupFromArr(field.paramters);
        }
        else {
            /** @type {?} */
            const controlConfig = {
                value: this.formValuesJson[field.name],
                disabled: field.disable
            };
            /** @type {?} */
            const validations = getFieldValidations(field);
            obj[field.name] = new FormControl(controlConfig, { validators: validations, updateOn: "change" });
        }
        return obj;
    }
}
FormTabService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FormTabService.ctorParameters = () => [];
/** @nocollapse */ FormTabService.ɵprov = ɵɵdefineInjectable({ factory: function FormTabService_Factory() { return new FormTabService(); }, token: FormTabService, providedIn: "root" });
if (false) {
    /** @type {?} */
    FormTabService.prototype.formJson;
    /** @type {?} */
    FormTabService.prototype.formValuesJson;
    /**
     * @type {?}
     * @private
     */
    FormTabService.prototype.ruleValidatedControls;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-tab.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormTabComponent {
    constructor() {
        this.applyDefault = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // TODO: fix this, temp solution to an error suggesting formJson is an empty object
        if (!Array.isArray(this.formJson))
            this.formJson = [];
    }
    /**
     * @param {?} field
     * @return {?}
     */
    updateVisibility(field) {
        this.updateformJSON(field, this.formJson);
    }
    // TODO:should we have dependency in fields with the same parent or not ? 
    /**
     * @param {?} field
     * @param {?} form
     * @return {?}
     */
    updateformJSON(field, form) {
        form.forEach((/**
         * @param {?} el
         * @return {?}
         */
        el => {
            if (el.name != field) {
                if (el.type == "object") {
                    this.updateformJSON(field, el.parameters);
                }
            }
            else {
                //update visibility for the field
                el.visible = true;
                return el;
            }
        }));
    }
}
FormTabComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-form-tab',
                template: `
  <div *ngFor="let field of formJson">
    <lib-form-field [field]="field" [abstractControl]="form.get(field.name)" [applyDefault]="applyDefault">
      <ng-content></ng-content>
    </lib-form-field>
  </div>
  `
            }] }
];
/** @nocollapse */
FormTabComponent.ctorParameters = () => [];
FormTabComponent.propDecorators = {
    formJson: [{ type: Input }],
    form: [{ type: Input }],
    applyDefault: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    FormTabComponent.prototype.formJson;
    /** @type {?} */
    FormTabComponent.prototype.form;
    /** @type {?} */
    FormTabComponent.prototype.applyDefault;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/util/google-places.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Google Maps helper methods
/** @type {?} */
const autofillAddress = (/**
 * @param {?} place
 * @param {?} addressForm
 * @param {?} lookup
 * @return {?}
 */
(place, addressForm, lookup) => {
    // Fetch address components
    /** @type {?} */
    const address = place['formatted_address'];
    /** @type {?} */
    const city = getCity(place);
    /** @type {?} */
    var province = getProvince(place);
    /** @type {?} */
    const postalCode = getPostCode(place);
    /** @type {?} */
    const country = getCountry(place);
    /** @type {?} */
    const streetNumber = getStreetNumber(place);
    /** @type {?} */
    const route = getRoute(place);
    /** @type {?} */
    const provinceField = Object.keys(addressForm.value).find((/**
     * @param {?} key
     * @return {?}
     */
    key => key.includes("Province")));
    if (!lookup.values[provinceField].find((/**
     * @param {?} key
     * @return {?}
     */
    key => key.value === province))) {
        province = null;
    }
    // Autofill forms
    addressForm.patchValue({
        LocationStreetAddressTxt: `${streetNumber} ${route}`,
        LocationAddressMunicipalityTxt: city,
        LocationAddressProvinceTxt: province,
        LocationAddressCountryTxt: country,
        LocationAddressPostalTxt: postalCode,
        LocationAddressTxt: `${streetNumber} ${route}`,
        LocationCityCd: city,
        LocationProvinceCd: province,
        LocationCountryCd: country,
        LocationPostalCodeTxt: postalCode,
        ClientAddressCountryCd: country,
        ClientAddressPostalTxt: postalCode,
        ClientAddressProvinceCd: province,
        ClientAddressMunicipalityTxt: city,
        ClientStreetAddressTxt: `${streetNumber} ${route}`,
        PolicyholderAddressCountryCd: country,
        PolicyholderAddressMunicipalityTxt: city,
        PolicyholderAddressPostalTxt: postalCode,
        PolicyholderAddressProvinceCd: province,
        PolicyholderStreetAddressTxt: `${streetNumber} ${route}`,
        InterestAddressCountryCd: country,
        InterestAddressMunicipalityTxt: city,
        InterestAddressPostalTxt: postalCode,
        InterestAddressProvinceCd: province,
        InterestStreetAddressTxt: `${streetNumber} ${route}`,
        DriverStreetAddressTxt: `${streetNumber} ${route}`,
        DriverAddressCountryCd: country,
        DriverAddressProvinceCd: province,
        DriverAddressMunicipalityTxt: city,
        DriverAddressPostalTxt: postalCode
    });
});
/** @type {?} */
const getAddrComponent = (/**
 * @param {?} place
 * @param {?} componentTemplate
 * @return {?}
 */
(place, componentTemplate) => {
    /** @type {?} */
    let result;
    for (let i = 0; i < place.address_components.length; i++) {
        /** @type {?} */
        const addressType = place.address_components[i].types[0];
        if (componentTemplate[addressType]) {
            result = place.address_components[i][componentTemplate[addressType]];
            return result;
        }
    }
    return result;
});
const ɵ0$1 = getAddrComponent;
/** @type {?} */
const getCity = (/**
 * @param {?} place
 * @return {?}
 */
(place) => {
    /** @type {?} */
    const COMPONENT_TEMPLATE = { locality: 'long_name' };
    /** @type {?} */
    const city = getAddrComponent(place, COMPONENT_TEMPLATE);
    return city;
});
const ɵ1 = getCity;
/** @type {?} */
const getPostCode = (/**
 * @param {?} place
 * @return {?}
 */
(place) => {
    /** @type {?} */
    const COMPONENT_TEMPLATE = { postal_code: 'long_name' };
    /** @type {?} */
    const postCode = getAddrComponent(place, COMPONENT_TEMPLATE);
    return postCode;
});
const ɵ2 = getPostCode;
/** @type {?} */
const getProvince = (/**
 * @param {?} place
 * @return {?}
 */
(place) => {
    /** @type {?} */
    const COMPONENT_TEMPLATE = { administrative_area_level_1: 'short_name' };
    /** @type {?} */
    const province = getAddrComponent(place, COMPONENT_TEMPLATE);
    return province;
});
const ɵ3 = getProvince;
/** @type {?} */
const getCountry = (/**
 * @param {?} place
 * @return {?}
 */
(place) => {
    /** @type {?} */
    const COMPONENT_TEMPLATE = { country: 'short_name' };
    /** @type {?} */
    const country = getAddrComponent(place, COMPONENT_TEMPLATE);
    return country;
});
const ɵ4 = getCountry;
/** @type {?} */
const getRoute = (/**
 * @param {?} place
 * @return {?}
 */
(place) => {
    /** @type {?} */
    const COMPONENT_TEMPLATE = { route: 'long_name' };
    /** @type {?} */
    const route = getAddrComponent(place, COMPONENT_TEMPLATE);
    return route;
});
const ɵ5 = getRoute;
/** @type {?} */
const getStreetNumber = (/**
 * @param {?} place
 * @return {?}
 */
(place) => {
    /** @type {?} */
    const COMPONENT_TEMPLATE = { street_number: 'long_name' };
    /** @type {?} */
    const number = getAddrComponent(place, COMPONENT_TEMPLATE);
    return number;
});
const ɵ6 = getStreetNumber;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/shared/hide-form.rules.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const handleFormHiding = (/**
 * @param {?} forms
 * @param {?} formJson
 * @param {?} field
 * @return {?}
 */
(forms, formJson, field) => {
    /** @type {?} */
    let output = new Subject();
    /** @type {?} */
    let initial = false;
    for (let form of formJson) {
        if (form.hiding && form.name == field.name) {
            /** @type {?} */
            const hidingForm = forms.get(form.hiding.form);
            /** @type {?} */
            const dependency = hidingForm === null || hidingForm === void 0 ? void 0 : hidingForm.get(form.hiding.field);
            if (dependency == null)
                continue;
            /** @type {?} */
            const initialValue = ((/** @type {?} */ (hidingForm))).getRawValue();
            dependency.valueChanges.pipe(startWith(initialValue[form.hiding.field])).subscribe((/**
             * @param {?} value
             * @return {?}
             */
            value => {
                const { values } = form.hiding;
                /** @type {?} */
                const invertValues = (form.hiding.invertValues == undefined ? false : form.hiding.invertValues);
                if ((Array.isArray(values) && values.includes(value) != invertValues) ||
                    ((values != undefined && !Array.isArray(values)) && (values == value) != invertValues) ||
                    (values == undefined && value != invertValues)) {
                    output.next(true);
                    initial = true;
                }
                else {
                    output.next(false);
                    initial = false;
                }
            }));
            return { out: output.asObservable(), init: initial };
        }
    }
    output.next(false);
    initial = false;
    return { out: output.asObservable(), init: initial };
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/lookup.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FieldLookupService {
    constructor() {
        this.values = {};
        this.valueUpdates = new Subject();
        this.valueUpdates$ = this.valueUpdates.asObservable();
    }
    /**
     * @param {?} fieldName
     * @param {?} values
     * @return {?}
     */
    cacheValues(fieldName, values) {
        this.values[fieldName] = values;
    }
    /**
     * @param {?} fieldName
     * @param {?} newValues
     * @return {?}
     */
    initSelectValues(fieldName, newValues) {
        this.cacheValues(fieldName, newValues);
    }
    /**
     * @param {?} fieldName
     * @param {?} newValues
     * @return {?}
     */
    updateSelectValues(fieldName, newValues) {
        this.cacheValues(fieldName, newValues);
        this.valueUpdates.next({ fieldName, values: newValues });
    }
}
FieldLookupService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FieldLookupService.ctorParameters = () => [];
/** @nocollapse */ FieldLookupService.ɵprov = ɵɵdefineInjectable({ factory: function FieldLookupService_Factory() { return new FieldLookupService(); }, token: FieldLookupService, providedIn: "root" });
if (false) {
    /** @type {?} */
    FieldLookupService.prototype.values;
    /**
     * @type {?}
     * @private
     */
    FieldLookupService.prototype.valueUpdates;
    /** @type {?} */
    FieldLookupService.prototype.valueUpdates$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/util/filter-lookup.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const CANADIAN_PROVINCES = ["AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT"];
/**
 * @param {?} filterString
 * @param {?} allOptions
 * @return {?}
 */
function filterProvinceOptions(filterString, allOptions) {
    if (!allOptions) {
        return [];
    }
    switch (filterString) {
        case "CA":
            return allOptions.filter((/**
             * @param {?} option
             * @return {?}
             */
            option => CANADIAN_PROVINCES.includes(option.value)));
        case "US":
            return allOptions.filter((/**
             * @param {?} option
             * @return {?}
             */
            option => !CANADIAN_PROVINCES.includes(option.value)));
        default:
            return allOptions;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/util/select-options.util.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SelectOption() { }
if (false) {
    /** @type {?} */
    SelectOption.prototype.label;
    /** @type {?} */
    SelectOption.prototype.value;
}
/** @type {?} */
const CLEAR_OPTION = { label: "-- Clear --", value: "CLEAR_VALUES" };
/**
 * @param {?} options
 * @param {?} currentValue
 * @return {?}
 */
function applyClearOption(options, currentValue) {
    var _a;
    /** @type {?} */
    const opts = [...options];
    /** @type {?} */
    const showClear = !(currentValue == "" && typeof currentValue == "string") && currentValue != null;
    /** @type {?} */
    const hasClear = ((_a = opts[0]) === null || _a === void 0 ? void 0 : _a.value) === CLEAR_OPTION.value;
    if (!showClear && hasClear) {
        opts.shift();
    }
    else if (showClear && !hasClear) {
        opts.unshift(CLEAR_OPTION);
    }
    return opts;
}
/**
 * @param {?} fieldName
 * @return {?}
 */
function isProvinceOrJurisdictionField(fieldName) {
    return fieldName.includes("Province") || fieldName.includes("Jurisdiction");
}
/**
 * @param {?} parent
 * @return {?}
 */
function findCountryFilterControl(parent) {
    if (!parent || !('controls' in parent)) {
        return null;
    }
    /** @type {?} */
    const group = (/** @type {?} */ (parent));
    /** @type {?} */
    const countryKey = Object.keys(group.controls).find((/**
     * @param {?} key
     * @return {?}
     */
    key => (key.includes("Country") || key.includes("CountryCd")) &&
        !key.includes("Province") &&
        !key.includes("Jurisdiction")));
    return countryKey ? group.get(countryKey) : null;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/form-field/form-field.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Display errors even if the field hasn't been touched
class MyErrorStateMatcher {
    /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    isErrorState(control, form) {
        return control.errors != null;
    }
}
class FormFieldComponent {
    /**
     * @param {?} formtab
     * @param {?} lookupService
     */
    constructor(formtab, lookupService) {
        this.formtab = formtab;
        this.lookupService = lookupService;
        this.applyDefault = false;
        this.matcher = new MyErrorStateMatcher();
        this.resetFilter = false;
        this.hideField = false;
        this.minLength = null;
        this.maxLength = null;
        this.optionsSnapshot = [];
        this.subscriptions = new Subscription();
        this.displayOptionLabel = (/**
         * @param {?} value
         * @return {?}
         */
        (value) => this.getOptionText(this.optionsSnapshot, value));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.applyDefault) {
            this.loadDefault();
        }
        this._initialValidation(this.field);
        switch (this.field.type) {
            case "object":
                // if (this.abstractControl.disabled) this.handleDisabledForm()
                break;
            case "string":
                this._initStringField(this.field);
                break;
            case "number":
                this._initNumberField(this.field);
                break;
            case "checkbox":
                this._initCheckboxField(this.field);
                break;
            case "filter-select":
            case "select":
            case "search-select":
            case "yesno":
                this._initSelectField(this.field);
                break;
            case "date":
                this._initDateField();
                break;
            default:
                break;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * @private
     * @return {?}
     */
    loadDefault() {
        if (this.field.type != "object" &&
            this.abstractControl != null &&
            this.abstractControl.value == null &&
            this.field.defaultValue != null) {
            this.abstractControl.patchValue(this.field.defaultValue);
        }
    }
    /**
     * @private
     * @param {?} field
     * @return {?}
     */
    _initialValidation(field) {
        var _a, _b;
        if (this.formtab.form && this.formtab.formJson) {
            /** @type {?} */
            const formHiding = handleFormHiding(this.formtab.form, this.formtab.formJson, field);
            this.hideField = formHiding.init;
            formHiding.out.subscribe((/**
             * @param {?} value
             * @return {?}
             */
            value => {
                this.hideField = value;
            }));
        }
        if (field["modal-only"]) {
            this.hideField = true;
        }
        this.minLength = (_a = field.validations) === null || _a === void 0 ? void 0 : _a.minLength;
        this.maxLength = (_b = field.validations) === null || _b === void 0 ? void 0 : _b.maxLength;
    }
    /**
     * @return {?}
     */
    handleDisabledForm() {
        if (this.field["conditionalRequirements"] != undefined)
            this.abstractControl.enable();
    }
    /**
     * @return {?}
     */
    showSelectionPopup() {
        this.resetFilter = true;
        this.abstractControl.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    }
    // checks that search-select input matches either the lookup label or value. if it matches the label,
    // it sets the field's value to the lookup's value instead
    /**
     * @return {?}
     */
    handleSearchSelectInput() {
        if (this.abstractControl.value == "" || this.abstractControl.value == undefined || this.abstractControl.value == null)
            return;
        for (let value of this.optionsSnapshot) {
            if (value.value == this.abstractControl.value)
                return;
            else if (typeof this.abstractControl.value == "string" && value.label.toLowerCase() == this.abstractControl.value.toLowerCase()) {
                this.abstractControl.setValue(value.value);
                return;
            }
        }
        this.abstractControl.setErrors({ message: "Entered value is not a valid option. Please select an option from the selection menu." });
    }
    /**
     * @param {?} options
     * @param {?} value
     * @return {?}
     */
    getOptionText(options, value) {
        for (let option of options)
            if (option.value == value)
                return option.label;
        return '';
    }
    /**
     * @return {?}
     */
    fullRow() {
        // if (!this.field.class) { return false; }
        // return this.field.class.includes('row');
        return true;
    }
    /**
     * @param {?} name
     * @param {?} context
     * @param {?} fieldName
     * @param {?} config
     * @param {?} formValues
     * @return {?}
     */
    callFunc(name, context, fieldName, config, formValues) {
        if (!name) {
            return false;
        }
        /** @type {?} */
        const args = Array.prototype.slice.call(arguments, 2);
        return context[name].apply(context, args);
    }
    // String field related inits
    /**
     * @param {?} field
     * @return {?}
     */
    _initStringField(field) {
    }
    // Number field related inits
    /**
     * @param {?} field
     * @return {?}
     */
    _initNumberField(field) { }
    /**
     * @param {?} field
     * @return {?}
     */
    _initSelectField(field) {
        var _a;
        if (!((_a = field.options) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        /** @type {?} */
        const baseOptions = [...field.options];
        this.lookupService.cacheValues(field.name, baseOptions);
        if (baseOptions.length >= 35 && this.field.type == "select")
            this.field.type = "search-select";
        /** @type {?} */
        const baseOptions$ = this._buildBaseOptionsStream(field, baseOptions);
        this.options$ = combineLatest([
            baseOptions$,
            this.abstractControl.valueChanges.pipe(startWith(this.abstractControl.value))
        ]).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ([options, value]) => applyClearOption(options, value))), shareReplay(1));
        if (field.type == "search-select") {
            this.filteredOptions$ = combineLatest([
                this.options$,
                this.abstractControl.valueChanges.pipe(startWith(''))
            ]).pipe(map((/**
             * @param {?} __0
             * @return {?}
             */
            ([options, value]) => this._filterOptions(options, value))));
        }
        this.subscriptions.add(this.options$.subscribe((/**
         * @param {?} options
         * @return {?}
         */
        options => { this.optionsSnapshot = options; })));
    }
    /**
     * @private
     * @param {?} field
     * @param {?} baseOptions
     * @return {?}
     */
    _buildBaseOptionsStream(field, baseOptions) {
        /** @type {?} */
        const externalUpdates$ = this.lookupService.valueUpdates$.pipe(filter((/**
         * @param {?} update
         * @return {?}
         */
        update => update.fieldName === field.name)), map((/**
         * @param {?} update
         * @return {?}
         */
        update => update.values)));
        if (isProvinceOrJurisdictionField(field.name)) {
            /** @type {?} */
            const countryControl = findCountryFilterControl(this.abstractControl.parent);
            if (countryControl) {
                /** @type {?} */
                const countryFiltered$ = countryControl.valueChanges.pipe(startWith(countryControl.value), map((/**
                 * @param {?} country
                 * @return {?}
                 */
                country => filterProvinceOptions(country, baseOptions))));
                return merge(countryFiltered$, externalUpdates$);
            }
        }
        return merge(of(baseOptions), externalUpdates$);
    }
    /**
     * @private
     * @param {?} options
     * @param {?} value
     * @return {?}
     */
    _filterOptions(options, value) {
        if (this.resetFilter) {
            this.resetFilter = false;
            return options;
        }
        else if (typeof value != "string")
            return options;
        /** @type {?} */
        const filterValue = value.toLowerCase();
        return options.filter((/**
         * @param {?} option
         * @return {?}
         */
        option => option.label.toLowerCase().includes(filterValue)));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    checkSelectClear(value) {
        if (value == "CLEAR_VALUES") {
            this.abstractControl.reset();
            this.abstractControl.setValue(null);
        }
    }
    /**
     * @param {?} field
     * @return {?}
     */
    _initCheckboxField(field) {
        if (this.abstractControl.value !== true) {
            this.abstractControl.setValue(false);
        }
    }
    /**
     * @return {?}
     */
    _initDateField() {
        if (typeof this.abstractControl.value == "string" && this.abstractControl.value.length > 0) {
            /** @type {?} */
            const date = this.abstractControl.value.split("-");
            if (date.length == 3) {
                this.abstractControl.setValue(date[0] + "-" + date[1].padStart(2, "0") + "-" + date[2].padStart(2, "0"));
            }
        }
    }
    /**
     * @param {?} place
     * @return {?}
     */
    getAddress(place) {
        place.address_components && autofillAddress(place, this.abstractControl.parent, this.lookupService);
    }
    /**
     * @param {?} control
     * @return {?}
     */
    onBlurNumber(control) {
        /** @type {?} */
        const val = Number(control.value);
        if (isNaN(val)) {
            control.setValue(null);
        }
        else {
            control.setValue(val);
        }
    }
    /**
     * @param {?} iso
     * @return {?}
     */
    toFormattedDate(iso) {
        /** @type {?} */
        const date = new Date(iso);
        /** @type {?} */
        const formattedDate = "" + date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, "0") +
            "-" + date.getDate().toString().padStart(2, "0");
        this.abstractControl.setValue(formattedDate);
        this.abstractControl.markAsDirty();
    }
}
FormFieldComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-form-field',
                template: "<div [ngSwitch]=\"field.type\" *ngIf=\"field.visible && !hideField && !abstractControl['hidden']\">\n  <div *ngSwitchCase=\"'object'\">\n    <div *ngIf=\"field.parameters != null\">\n      <div class=\"card-wrapper\" *ngIf=\"field.expandable\" id=\"form-section\">\n        <mat-expansion-panel hideToggle>\n          <mat-expansion-panel-header>\n            <mat-panel-title>\n              <!-- Expanding title -->\n              {{ field.label }}\n            </mat-panel-title>\n          </mat-expansion-panel-header>\n          <div *ngFor=\"let f of field.parameters; let i = index\">\n            <lib-form-field *ngIf=\"f.visible && !abstractControl.get(f.name)['hidden']\" class=\"object-fields\" [field]=\"f\" [abstractControl]=\"abstractControl.get(f.name)\"\n              class=\"section-wrapper {{f.class}} {{f.type}}-wrapper\" [applyDefault]=\"applyDefault\">\n            </lib-form-field>\n            <ng-content></ng-content>\n          </div>\n        </mat-expansion-panel>\n      </div>\n      <div class=\"card-wrapper\" *ngIf=\"!field.expandable\">\n        <mat-card class=\"mat-card\">\n          <mat-card-title>\n            <!-- Not expanding title -->\n            {{ field.label }}\n          </mat-card-title>\n          <mat-card-content class=\"mat-card-content\">\n            <div *ngFor=\"let f of field.parameters; let i = index\"\n              [ngClass]=\"{'input-full-row' : f.class.includes('full-row')}\">\n              <lib-form-field *ngIf=\"f.visible && !abstractControl.get(f.name)['hidden']\" class=\"object-fields\" [field]=\"f\" [abstractControl]=\"abstractControl.get(f.name)\"\n                class=\"section-wrapper {{f.class}} {{f.type}}-wrapper\" [applyDefault]=\"applyDefault\">\n              </lib-form-field>\n            </div>\n            <ng-content></ng-content>\n          </mat-card-content>\n        </mat-card>\n      </div>\n      <div *ngIf=\"abstractControl.errors\" class=\"error-wrapper\">\n        <div *ngIf=\"abstractControl.errors.message\" class=\"error-field\">\n          * {{abstractControl.errors.message}}</div>\n      </div>\n    </div>\n  </div>\n  <!--STRING INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'string'\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full select-field-height\">\n        <mat-label>{{field.label}}</mat-label>\n        <input matInput [id]=\"field.name\" [name]=\"field.name\" [formControl]=\"abstractControl\" type=\"text\"\n          [errorStateMatcher]=\"matcher\" [attr.minlength]=\"minLength\" [attr.maxlength]=\"maxLength\" />\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.message\">\n          * {{abstractControl.errors.message}}</mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.email\">* Must enter a valid email address\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <!--GOOGLE AUTOFILL ADDRESS INPUT-->\n  <div *ngSwitchCase=\"'address'\">\n    <lib-autofill-address id=\"GoogleAddressAutocomplete\" (setAddress)=\"getAddress($event)\" [field]=\"field\"\n      [abstractControl]=\"abstractControl\">>\n    </lib-autofill-address>\n  </div>\n  <!--NUMBER INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'number'\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full select-field-height\">\n        <mat-label>{{field.label}}</mat-label>\n        <input matInput [id]=\"field.name\" [name]=\"field.name\" [formControl]=\"abstractControl\" type=\"text\"\n          [errorStateMatcher]=\"matcher\" (blur)=\"onBlurNumber(abstractControl)\" mask=\"separator\" thousandSeparator=\",\"\n          placeHolderCharacter=\"\" [attr.minlength]=\"minLength\" [attr.maxlength]=\"maxLength\" />\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.message\">* {{abstractControl.errors.message}}\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.min\">* Must be at least\n          {{abstractControl.errors.min.min}}\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.max\">* Must be at most\n          {{abstractControl.errors.max.max}}\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <!--YEAR INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'year'\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full select-field-height\">\n        <mat-label>{{field.label}}</mat-label>\n        <input matInput [id]=\"field.name\" [name]=\"field.name\" [formControl]=\"abstractControl\" type=\"number\"\n          [errorStateMatcher]=\"matcher\" />\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.message\">* {{abstractControl.errors.message}}\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <!--PHONE NUMBER INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'phoneNumber'\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full select-field-height\">\n        <mat-label>{{field.label}}</mat-label>\n        <input matInput [id]=\"field.name\" [name]=\"field.name\" [formControl]=\"abstractControl\" type=\"text\"\n          [errorStateMatcher]=\"matcher\" mask=\"(000) 000 0000\" />\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.message\">* {{abstractControl.errors.message}}\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <!--SELECT INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'select'\" class=\"select-selecterson\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full\">\n        <mat-label>{{field.label}}</mat-label>\n        <mat-select [id]=\"field.name\" [formControl]=\"abstractControl\" [errorStateMatcher]=\"matcher\">\n          <mat-option #matOption *ngFor=\"let x of options$ | async\" [value]=\"x.value\" [id]=\"x.value\"\n            (click)=\"checkSelectClear(matOption.value)\">\n            {{x.label}}\n          </mat-option>\n        </mat-select>\n        <mat-error\n          *ngIf=\"abstractControl.errors && abstractControl.errors.state && !abstractControl.errors.state.isValid\">\n          {{abstractControl.errors.state.message}}</mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <!--FILTERED SELECT INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'filter-select'\" class=\"select-selecterson\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full\">\n        <mat-label>{{field.label}}</mat-label>\n        <mat-select [id]=\"field.name\" [formControl]=\"abstractControl\" [errorStateMatcher]=\"matcher\">\n          <mat-option #matOption *ngFor=\"let x of options$ | async\" [value]=\"x.value\" [id]=\"x.value\"\n            (click)=\"checkSelectClear(matOption.value)\">\n            {{x.label}}\n          </mat-option>\n        </mat-select>\n        <mat-error\n          *ngIf=\"abstractControl.errors && abstractControl.errors.state && !abstractControl.errors.state.isValid\">\n          {{abstractControl.errors.state.message}}</mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors?.message\">\n          * {{abstractControl.errors.message}}\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <!--YESNO INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'yesno'\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full\">\n        <mat-label>{{field.label}}</mat-label>\n        <mat-select [id]=\"field.name\" [formControl]=\"abstractControl\" [errorStateMatcher]=\"matcher\">\n          <mat-option #matOption *ngFor=\"let x of options$ | async\" [value]=\"x.value\"\n            (click)=\"checkSelectClear(matOption.value)\">\n            {{x.label}}\n          </mat-option>\n        </mat-select>\n        <mat-error\n          *ngIf=\"abstractControl.errors && abstractControl.errors.state && !abstractControl.errors.state.isValid\">\n          {{abstractControl.errors.state.message}}</mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors?.message\">\n          * {{abstractControl.errors.message}}\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <!--DATE INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'date'\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full date-wrapper\">\n        <mat-label>{{field.label}}</mat-label>\n        <input matInput [id]=\"field.name\" [formControl]=\"abstractControl\" [errorStateMatcher]=\"matcher\">\n        <input type=\"hidden\" [matDatepicker]=\"picker\" [disabled]=\"abstractControl.disabled ? '' : null\"\n          (dateChange)=\"toFormattedDate($event.value)\" max=\"2100-12-31\" min=\"1900-01-01\">\n        <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n        <mat-datepicker #picker></mat-datepicker>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.message\">\n          * {{abstractControl.errors.message}}\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">\n          * Required\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.matDatepickerMin\">\n          Year cannot be below 1900\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.matDatepickerMax\">\n          Year cannot be beyond 2100\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.matDatepickerParse\">\n          Date not formatted correctly\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <!--CHECKBOX INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'checkbox'\" class=\"checkbox-bottom checkbox-field\">\n      <mat-label [ngClass]=\"{'label-disabled' : abstractControl.disabled}\" class=\"checkbox-label\">{{field.label}}\n      </mat-label>\n      <mat-checkbox class=\"checkbox-box\" [name]=\"field.name\" [formControl]=\"abstractControl\"></mat-checkbox>\n      <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.message\">* {{abstractControl.errors.message}}\n      </mat-error>\n      <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n      </mat-error>\n    </div>\n  </ng-container>\n  <!--RADIO BUTTON INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'radiobutton'\" class=\"radio-field\">\n      <p>{{field.label}}</p>\n      <div class=\"radiobutton\" *ngFor=\"let x of field.options\">\n        <input [id]=\"field.name\" [attr.disabled]=\"false?'':null\" [ngClass]=\"{'input-disabled' : false}\"\n          class=\"form-radio-input \" type=\"radio\" [name]=\"field.label\" [value]=\"x.value\" [formControl]=\"abstractControl\">\n        <label class=\"form-radio-label\" [for]=\"x.label\">{{x.label}}</label><br>\n      </div>\n    </div>\n  </ng-container>\n  <!--SEARCHED SELECT INPUT-->\n  <ng-container>\n    <div *ngSwitchCase=\"'search-select'\">\n      <mat-form-field appearance=\"fill\" class=\"form-input-full select-field-height\" (click)=\"showSelectionPopup()\">\n        <mat-label>{{field.label}}</mat-label>\n        <input matInput [id]=\"field.name\" [name]=\"field.name\" [formControl]=\"abstractControl\" [matAutocomplete]=\"auto\"\n          type=\"text\" [errorStateMatcher]=\"matcher\" (blur)=\"handleSearchSelectInput()\" />\n        <mat-autocomplete autoActiveFirstOption #auto=\"matAutocomplete\"\n          [displayWith]=\"displayOptionLabel\">\n          <mat-option #matOption *ngFor=\"let option of filteredOptions$ | async\" [value]=\"option.value\"\n            (click)=\"checkSelectClear(matOption.value)\">\n            {{option.label}}\n          </mat-option>\n        </mat-autocomplete>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.message\">* {{abstractControl.errors.message}}\n        </mat-error>\n        <mat-error *ngIf=\"abstractControl.errors && abstractControl.errors.required\">* Required\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </ng-container>\n  <ng-container>\n    <div *ngSwitchCase=\"'label'\">\n      <p [id]=\"field.name\" class=\"form-input-label\">{{field.label}}</p>\n    </div>\n  </ng-container>\n</div>\n",
                styles: [".mat-card{display:flex;flex-wrap:wrap;padding:25px}.mat-card-title{font-size:20px;letter-spacing:1.2px;margin-bottom:26px;width:100%}.mat-card-content{width:100%}.section-wrapper{float:left}.form-input{background-color:#fcfcfc;border:1px solid #cacaca;border-radius:3px;box-sizing:border-box;display:block;height:36px;margin-top:6px;padding:0 15px;width:100%}.form-input-full{width:100%}.form-input-label{color:#666;font-family:Roboto,Helvetica Neue,sans-serif;font-weight:500;letter-spacing:.5px;margin-bottom:24px;margin-top:0}.radiobutton{margin:0 5px 0 0;position:relative}.header-2{color:var(--primary-color);float:left;font-family:Roboto,Helvetica Neue,sans-serif;font-size:20px;margin-bottom:25px}.object-fields{float:left;padding:10px;width:100%}.input-disabled{background-color:#e0e0e0;border-color:#cdcdcd}.input-full-row{float:left;width:100%}.clear-right{margin-right:100%}.clear-left{clear:left}.form6-col-1{float:left;margin-left:1.25%;width:15.625%}.form6-col-1-first{clear:left;float:left;margin-left:0;width:15.625%}.form6-col-1-wide{float:left;margin-left:1.23457%;width:16.875%}.form6-col-2{float:left;margin-left:1.25%;width:32.5%}.form6-col-2-first{clear:left;float:left;margin-left:0;width:32.5%}.form6-col-2-wide{float:left;margin-left:1.23457%;width:33.75%}.form6-col-3{float:left;margin-left:1.25%;width:49.375%}.form6-col-3-first{clear:left;float:left;margin-left:0;width:49.375%}.form6-col-3-wide{float:left;margin-left:1.23457%;width:50.625%}.form6-col-4{float:left;margin-left:1.25%;width:66.25%}.form6-col-4-first{clear:left;float:left;margin-left:0;width:66.25%}.form6-col-4-wide{float:left;margin-left:1.23457%;width:67.5%}.form6-col-5{float:left;margin-left:1.25%;width:83.125%}.form6-col-5-first{clear:left;float:left;margin-left:0;width:83.125%}.form6-col-5-wide{float:left;margin-left:1.23457%;width:84.375%}.form6-col-6{margin-right:0}.form6-col-6,.form6-col-6-first{float:left;margin-left:0;width:100%}.form6-col-6-first{clear:left}.form6-col-6-wide{float:left;margin-left:0;margin-right:0;width:101.25%}.form7-col-1{float:left;margin-left:1.06952%;width:13.36898%}.form7-col-1-first{clear:left;float:left;margin-left:0;width:13.36898%}.form7-col-1-wide{float:left;margin-left:1.0582%;width:14.4385%}.form7-col-2{float:left;margin-left:1.06952%;width:27.80749%}.form7-col-2-first{clear:left;float:left;margin-left:0;width:27.80749%}.form7-col-2-wide{float:left;margin-left:1.0582%;width:28.87701%}.form7-col-3{float:left;margin-left:1.06952%;width:42.24599%}.form7-col-3-first{clear:left;float:left;margin-left:0;width:42.24599%}.form7-col-3-wide{float:left;margin-left:1.0582%;width:43.31551%}.form7-col-4{float:left;margin-left:1.06952%;width:56.68449%}.form7-col-4-first{clear:left;float:left;margin-left:0;width:56.68449%}.form7-col-4-wide{float:left;margin-left:1.0582%;width:57.75401%}.form7-col-5{float:left;margin-left:1.06952%;width:71.12299%}.form7-col-5-first{clear:left;float:left;margin-left:0;width:71.12299%}.form7-col-5-wide{float:left;margin-left:1.0582%;width:72.19251%}.form7-col-6{float:left;margin-left:1.06952%;width:85.5615%}.form7-col-6-first{clear:left;float:left;margin-left:0;width:85.5615%}.form7-col-6-wide{float:left;margin-left:1.0582%;width:86.63102%}.form7-col-7{margin-right:0}.form7-col-7,.form7-col-7-first{float:left;margin-left:0;width:100%}.form7-col-7-first{clear:left}.form7-col-7-wide{float:left;margin-left:0;margin-right:0;width:101.06952%}.form8-col-1{float:left;margin-left:.93458%;width:11.68224%}.form8-col-1-first{clear:left;float:left;margin-left:0;width:11.68224%}.form8-col-1-wide{float:left;margin-left:.92593%;width:12.61682%}.form8-col-2{float:left;margin-left:.93458%;width:24.29907%}.form8-col-2-first{clear:left;float:left;margin-left:0;width:24.29907%}.form8-col-2-wide{float:left;margin-left:.92593%;width:25.23364%}.form8-col-3{float:left;margin-left:.93458%;width:36.91589%}.form8-col-3-first{clear:left;float:left;margin-left:0;width:36.91589%}.form8-col-3-wide{float:left;margin-left:.92593%;width:37.85047%}.form8-col-4{float:left;margin-left:.93458%;width:49.53271%}.form8-col-4-first{clear:left;float:left;margin-left:0;width:49.53271%}.form8-col-4-wide{float:left;margin-left:.92593%;width:50.46729%}.form8-col-5{float:left;margin-left:.93458%;width:62.14953%}.form8-col-5-first{clear:left;float:left;margin-left:0;width:62.14953%}.form8-col-5-wide{float:left;margin-left:.92593%;width:63.08411%}.form8-col-6{float:left;margin-left:.93458%;width:74.76636%}.form8-col-6-first{clear:left;float:left;margin-left:0;width:74.76636%}.form8-col-6-wide{float:left;margin-left:.92593%;width:75.70093%}.form8-col-7{float:left;margin-left:.93458%;width:87.38318%}.form8-col-7-first{clear:left;float:left;margin-left:0;width:87.38318%}.form8-col-7-wide{float:left;margin-left:.92593%;width:88.31776%}.form8-col-8{margin-right:0}.form8-col-8,.form8-col-8-first{float:left;margin-left:0;width:100%}.form8-col-8-first{clear:left}.form8-col-8-wide{float:left;margin-left:0;margin-right:0;width:100.93458%}.form9-col-1{float:left;margin-left:.82988%;width:10.37344%}.form9-col-1-first{clear:left;float:left;margin-left:0;width:10.37344%}.form9-col-1-wide{float:left;margin-left:.82305%;width:11.20332%}.form9-col-2{float:left;margin-left:.82988%;width:21.57676%}.form9-col-2-first{clear:left;float:left;margin-left:0;width:21.57676%}.form9-col-2-wide{float:left;margin-left:.82305%;width:22.40664%}.form9-col-3{float:left;margin-left:.82988%;width:32.78008%}.form9-col-3-first{clear:left;float:left;margin-left:0;width:32.78008%}.form9-col-3-wide{float:left;margin-left:.82305%;width:33.60996%}.form9-col-4{float:left;margin-left:.82988%;width:43.9834%}.form9-col-4-first{clear:left;float:left;margin-left:0;width:43.9834%}.form9-col-4-wide{float:left;margin-left:.82305%;width:44.81328%}.form9-col-5{float:left;margin-left:.82988%;width:55.18672%}.form9-col-5-first{clear:left;float:left;margin-left:0;width:55.18672%}.form9-col-5-wide{float:left;margin-left:.82305%;width:56.0166%}.form9-col-6{float:left;margin-left:.82988%;width:66.39004%}.form9-col-6-first{clear:left;float:left;margin-left:0;width:66.39004%}.form9-col-6-wide{float:left;margin-left:.82305%;width:67.21992%}.form9-col-7{float:left;margin-left:.82988%;width:77.59336%}.form9-col-7-first{clear:left;float:left;margin-left:0;width:77.59336%}.form9-col-7-wide{float:left;margin-left:.82305%;width:78.42324%}.form9-col-8{float:left;margin-left:.82988%;width:88.79668%}.form9-col-8-first{clear:left;float:left;margin-left:0;width:88.79668%}.form9-col-8-wide{float:left;margin-left:.82305%;width:89.62656%}.form9-col-9{margin-right:0}.form9-col-9,.form9-col-9-first{float:left;margin-left:0;width:100%}.form9-col-9-first{clear:left}.form9-col-9-wide{float:left;margin-left:0;margin-right:0;width:100.82988%}.form12-col-1{float:left;margin-left:.62112%;width:7.76397%}.form12-col-1-first{clear:left;float:left;margin-left:0;width:7.76397%}.form12-col-1-wide{float:left;margin-left:.61728%;width:8.38509%}.form12-col-2{float:left;margin-left:.62112%;width:16.14906%}.form12-col-2-first{clear:left;float:left;margin-left:0;width:16.14906%}.form12-col-2-wide{float:left;margin-left:.61728%;width:16.77019%}.form12-col-3{float:left;margin-left:.62112%;width:24.53416%}.form12-col-3-first{clear:left;float:left;margin-left:0;width:24.53416%}.form12-col-3-wide{float:left;margin-left:.61728%;width:25.15528%}.form12-col-4{float:left;margin-left:.62112%;width:32.91925%}.form12-col-4-first{clear:left;float:left;margin-left:0;width:32.91925%}.form12-col-4-wide{float:left;margin-left:.61728%;width:33.54037%}.form12-col-5{float:left;margin-left:.62112%;width:41.30435%}.form12-col-5-first{clear:left;float:left;margin-left:0;width:41.30435%}.form12-col-5-wide{float:left;margin-left:.61728%;width:41.92547%}.form12-col-6{float:left;margin-left:.62112%;width:49.68943%}.form12-col-6-first{clear:left;float:left;margin-left:0;width:49.68943%}.form12-col-6-wide{float:left;margin-left:.61728%;width:50.31056%}.form12-col-7{float:left;margin-left:.62112%;width:58.07452%}.form12-col-7-first{clear:left;float:left;margin-left:0;width:58.07452%}.form12-col-7-wide{float:left;margin-left:.61728%;width:58.69565%}.form12-col-8{float:left;margin-left:.62112%;width:66.45961%}.form12-col-8-first{clear:left;float:left;margin-left:0;width:66.45961%}.form12-col-8-wide{float:left;margin-left:.61728%;width:67.08075%}.form12-col-9{float:left;margin-left:.62112%;width:74.8447%}.form12-col-9-first{clear:left;float:left;margin-left:0;width:74.8447%}.form12-col-9-wide{float:left;margin-left:.61728%;width:75.46584%}.form12-col-10{float:left;margin-left:.62112%;width:83.22979%}.form12-col-10-first{clear:left;float:left;margin-left:0;width:83.22979%}.form12-col-10-wide{float:left;margin-left:.61728%;width:83.85093%}.form12-col-11{float:left;margin-left:.62112%;width:91.61488%}.form12-col-11-first{clear:left;float:left;margin-left:0;width:91.61488%}.form12-col-11-wide{float:left;margin-left:.61728%;width:92.23602%}.form12-col-12{float:left;margin-left:0;margin-right:0;width:100%}.form12-col-12-first{clear:left;float:left;margin-left:0;width:100%}.form12-col-12-wide{float:left;margin-left:0;margin-right:0;width:100.62112%}.form16-col-1{float:left;margin-left:.46512%;width:5.81395%}.form16-col-1-first{clear:left;float:left;margin-left:0;width:5.81395%}.form16-col-1-wide{float:left;margin-left:.46296%;width:6.27907%}.form16-col-2{float:left;margin-left:.46512%;width:12.09302%}.form16-col-2-first{clear:left;float:left;margin-left:0;width:12.09302%}.form16-col-2-wide{float:left;margin-left:.46296%;width:12.55814%}.form16-col-3{float:left;margin-left:.46512%;width:18.37209%}.form16-col-3-first{clear:left;float:left;margin-left:0;width:18.37209%}.form16-col-3-wide{float:left;margin-left:.46296%;width:18.83721%}.form16-col-4{float:left;margin-left:.46512%;width:24.65116%}.form16-col-4-first{clear:left;float:left;margin-left:0;width:24.65116%}.form16-col-4-wide{float:left;margin-left:.46296%;width:25.11628%}.form16-col-5{float:left;margin-left:.46512%;width:30.93023%}.form16-col-5-first{clear:left;float:left;margin-left:0;width:30.93023%}.form16-col-5-wide{float:left;margin-left:.46296%;width:31.39535%}.form16-col-6{float:left;margin-left:.46512%;width:37.2093%}.form16-col-6-first{clear:left;float:left;margin-left:0;width:37.2093%}.form16-col-6-wide{float:left;margin-left:.46296%;width:37.67442%}.form16-col-7{float:left;margin-left:.46512%;width:43.48837%}.form16-col-7-first{clear:left;float:left;margin-left:0;width:43.48837%}.form16-col-7-wide{float:left;margin-left:.46296%;width:43.95349%}.form16-col-8{float:left;margin-left:.46512%;width:49.76744%}.form16-col-8-first{clear:left;float:left;margin-left:0;width:49.76744%}.form16-col-8-wide{float:left;margin-left:.46296%;width:50.23256%}.form16-col-9{float:left;margin-left:.46512%;width:56.04651%}.form16-col-9-first{clear:left;float:left;margin-left:0;width:56.04651%}.form16-col-9-wide{float:left;margin-left:.46296%;width:56.51163%}.form16-col-10{float:left;margin-left:.46512%;width:62.32558%}.form16-col-10-first{clear:left;float:left;margin-left:0;width:62.32558%}.form16-col-10-wide{float:left;margin-left:.46296%;width:62.7907%}.form16-col-11{float:left;margin-left:.46512%;width:68.60465%}.form16-col-11-first{clear:left;float:left;margin-left:0;width:68.60465%}.form16-col-11-wide{float:left;margin-left:.46296%;width:69.06977%}.form16-col-12{float:left;margin-left:.46512%;width:74.88372%}.form16-col-12-first{clear:left;float:left;margin-left:0;width:74.88372%}.form16-col-12-wide{float:left;margin-left:.46296%;width:75.34884%}.form16-col-13{float:left;margin-left:.46512%;width:81.16279%}.form16-col-13-first{clear:left;float:left;margin-left:0;width:81.16279%}.form16-col-13-wide{float:left;margin-left:.46296%;width:81.62791%}.form16-col-14{float:left;margin-left:.46512%;width:87.44186%}.form16-col-14-first{clear:left;float:left;margin-left:0;width:87.44186%}.form16-col-14-wide{float:left;margin-left:.46296%;width:87.90698%}.form16-col-15{float:left;margin-left:.46512%;width:93.72093%}.form16-col-15-first{clear:left;float:left;margin-left:0;width:93.72093%}.form16-col-15-wide{float:left;margin-left:.46296%;width:94.18605%}.form16-col-16{float:left;margin-left:0;margin-right:0;width:100%}.form16-col-16-first{clear:left;float:left;margin-left:0;width:100%}.form16-col-16-wide{width:100.46512%}.form16-col-16-wide,.form-left{float:left;margin-left:0;margin-right:0}.form-left{width:40%}.form-right{float:right;margin-left:0;width:40%}.error-field{color:#b51a2d;font-size:12px}.card-wrapper{float:left;margin-bottom:30px;width:100%}.string-wrapper{margin-bottom:10px}.checkbox-wrapper{margin-bottom:0}.select-wrapper,.yesno-wrapper{margin-bottom:10px}.date-wrapper{margin-bottom:5px;.mat-form-field-suffix{position:absolute;right:15px}}.address-wrapper,.number-wrapper,.phoneNumber-wrapper,.search-select-wrapper,.year-wrapper{margin-bottom:10px}.select-field{-moz-appearance:none;-webkit-appearance:none;background-image:linear-gradient(45deg,transparent 50%,grey 0),linear-gradient(135deg,grey 50%,transparent 0),linear-gradient(90deg,#ccc,#ccc);background-position:calc(100% - 17px) calc(1em + 4px),calc(100% - 12px) calc(1em + 4px),calc(100% - 2.5em) .5em;background-repeat:no-repeat;background-size:5px 5px,5px 5px,1px 1.7em;border-radius:3px;cursor:pointer}.input-disabled{background-color:#ddd;border:1px solid #cdcdcd;cursor:default}.input-hidden{display:block;display:none}.checkbox-field{height:16px}.checkbox-box{float:left;margin:0 10px 0 0}.checkbox-label{display:inline-block;margin-top:2px;width:calc(100% - 26px)}.checkbox-bottom{margin-bottom:33.81px}.label-disabled{color:rgba(0,0,0,.38)}::ng-deep .select-field-height div.mat-form-field-wrapper{height:52.06px}::-webkit-datetime-edit{color:#777}.variable-height-field .checkbox-field{height:auto;margin-bottom:16px}.center-content-vertical .checkbox-field{margin-bottom:17px;margin-top:16.81px}::ng-deep input[type=number]::-webkit-inner-spin-button,::ng-deep input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}"]
            }] }
];
/** @nocollapse */
FormFieldComponent.ctorParameters = () => [
    { type: FormTabComponent },
    { type: FieldLookupService }
];
FormFieldComponent.propDecorators = {
    abstractControl: [{ type: Input }],
    field: [{ type: Input }],
    applyDefault: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    FormFieldComponent.prototype.abstractControl;
    /** @type {?} */
    FormFieldComponent.prototype.field;
    /** @type {?} */
    FormFieldComponent.prototype.applyDefault;
    /** @type {?} */
    FormFieldComponent.prototype.matcher;
    /** @type {?} */
    FormFieldComponent.prototype.options$;
    /** @type {?} */
    FormFieldComponent.prototype.filteredOptions$;
    /** @type {?} */
    FormFieldComponent.prototype.resetFilter;
    /** @type {?} */
    FormFieldComponent.prototype.hideField;
    /** @type {?} */
    FormFieldComponent.prototype.minLength;
    /** @type {?} */
    FormFieldComponent.prototype.maxLength;
    /**
     * @type {?}
     * @private
     */
    FormFieldComponent.prototype.optionsSnapshot;
    /**
     * @type {?}
     * @private
     */
    FormFieldComponent.prototype.subscriptions;
    /** @type {?} */
    FormFieldComponent.prototype.displayOptionLabel;
    /** @type {?} */
    FormFieldComponent.prototype.formtab;
    /**
     * @type {?}
     * @private
     */
    FormFieldComponent.prototype.lookupService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/autofill-address/autofill-address.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AutofillAddressComponent {
    /**
     * @param {?} formTabService
     * @param {?} formtab
     */
    constructor(formTabService, formtab) {
        this.formTabService = formTabService;
        this.formtab = formtab;
        this.setAddress = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.getPlaceAutocomplete();
    }
    /**
     * @return {?}
     */
    getPlaceAutocomplete() {
        /** @type {?} */
        const autocomplete = new google.maps.places.Autocomplete(this.addressText.nativeElement, {
            componentRestrictions: { country: "CA" },
            types: ['address']
        });
        google.maps.event.addListener(autocomplete, 'place_changed', (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const place = autocomplete.getPlace();
            this.invokeEvent(place);
        }));
    }
    /**
     * @param {?} place
     * @return {?}
     */
    invokeEvent(place) {
        this.setAddress.emit(place);
    }
}
AutofillAddressComponent.decorators = [
    { type: Component, args: [{
                selector: 'lib-autofill-address',
                template: "<div>\n    <mat-form-field appearance=\"fill\" class=\"form-input-full\">\n        <mat-label>{{field.label}}</mat-label>\n        <input matInput #addressText [name]=\"field.name\" [formControl]=\"abstractControl\" type=\"text\" />\n    </mat-form-field>\n</div>",
                styles: [".form-input-full{width:100%}"]
            }] }
];
/** @nocollapse */
AutofillAddressComponent.ctorParameters = () => [
    { type: FormTabService },
    { type: FormTabComponent }
];
AutofillAddressComponent.propDecorators = {
    abstractControl: [{ type: Input }],
    field: [{ type: Input }],
    addressType: [{ type: Input }],
    setAddress: [{ type: Output }],
    addressText: [{ type: ViewChild, args: ["addressText", { static: false },] }]
};
if (false) {
    /** @type {?} */
    AutofillAddressComponent.prototype.abstractControl;
    /** @type {?} */
    AutofillAddressComponent.prototype.field;
    /** @type {?} */
    AutofillAddressComponent.prototype.addressType;
    /** @type {?} */
    AutofillAddressComponent.prototype.setAddress;
    /** @type {?} */
    AutofillAddressComponent.prototype.addressText;
    /** @type {?} */
    AutofillAddressComponent.prototype.formTabService;
    /** @type {?} */
    AutofillAddressComponent.prototype.formtab;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/form-tab.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormTabModule {
}
FormTabModule.decorators = [
    { type: NgModule, args: [{
                declarations: [FormTabComponent, FormFieldComponent, AutofillAddressComponent],
                imports: [
                    ReactiveFormsModule,
                    FormsModule,
                    CommonModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatCardModule,
                    MatExpansionModule,
                    MatAutocompleteModule,
                    MatSelectModule,
                    MatDatepickerModule,
                    MatCheckboxModule,
                    NgxMaskModule.forRoot({
                        showMaskTyped: true
                    })
                ],
                exports: [FormTabComponent],
                providers: [FormTabService, FieldLookupService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: form-tab.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { FormTabComponent, FormTabModule, FormTabService, FormFieldComponent as ɵa, FieldLookupService as ɵb, AutofillAddressComponent as ɵc };
//# sourceMappingURL=form-tab.js.map
